/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const CDP_STRINGS = {
  add: `Add`,
  addAttribute: `Add attribute`,
  addEventFeed: `Add event feed`,
  addRulesetLabel: `Add a rule set`,
  addSegment: `Add segment`,
  addSuccessMetric: `Add success metrics`,
  addSuccessMetricDescription: `Add success metrics to this segment by adding one or more event feeds. Only website behaviors are supported.`,
  and: `And`,
  apply: `Apply`,
  attribute: `Attribute`,
  attributeDeleteMapping: `Delete mapping`,
  attributeEnter: `Enter attribute`,
  attributeFilters: `Attribute filters`,
  attributeFiltersDescription: `Add and define event attributes in the fields below. ALL defined attributes need to match for an event to be captured.`,
  attributeMapping: `Attribute mapping`,
  attributeMappingTableDescription: `Use the following table to add attributes from the event data to consolidate them into the single customer view.`,
  attributes: `Attributes`,
  attributeSelectLabel: `Attribute`,
  attributeSelectPlaceholder: `Select an attribute`,
  attributeTableHeaderFrom: `From event data`,
  attributeTableHeaderTo: `To single customer view`,
  attributeTextfieldFrom: `Enter attribute from event data`,
  attributeTextfieldTo: `Enter attribute to single customer view`,
  attributeUniqueIdentifier: `Unique identifier attribute`,
  attributeUniqueIdentifierNote: `This attribute is used as the unique identifier to lookup and match the record from the event.`,
  basicAttributes: `Basic attributes`,
  cancel: `Cancel`,
  countFieldLabel: `Count`,
  countFieldPlaceholder: `Enter a number`,
  created: `Created`,
  createDataIntegrationEventFeed: `Create data integration event feed`,
  createEvent: `Add event`,
  createEventFeed: `Create event feed`,
  createSegment: `Create a segment`,
  createWebBehaviorEventFeed: `Create website behavior event feed`,
  customerId: `Customer ID`,
  customerProfile: `Customer profile`,
  customers: `Customers`,
  customerSearchNoResult: `There are no matching customers.`,
  customerSearchPlaceholder: `Search customers by customer ID, name, or email`,
  dashboard: `Dashboard`,
  dashboardCustomers: `Customers`,
  dashboardErrors: `Errors`,
  dashboardEvents: `Events`,
  dashboardSegments: `Segments`,
  dashboardTotalCustomers: `Total customers`,
  dashboardTotalSegments: `Total segments`,
  dataIntegration: `Data integration`,
  delete: `Delete`,
  deleteCustomer: `Delete customer`,
  deleteCustomerDescription: `If you delete this customer, your content will not be retrievable.`,
  deleteEventDialogDeleteButton: `Delete event`,
  deleteEventDialogErrorMessage: `Failed to delete event`,
  deleteEventDialogHeading: `Delete event`,
  deleteEventDialogMessage: `If you delete this event, your content will not be retrievable.`,
  deleteFilter: `Delete filter`,
  deleteSegmentDialogDeleteButton: `Delete segment`,
  deleteSegmentDialogErrorMessage: `Failed to delete segment`,
  deleteSegmentDialogHeading: `Are you sure?`,
  deleteSegmentDialogMessage: `If you delete this segment, your content will not be retrievable.`,
  deleteSegmentGroupDialogMessage: `If you delete this segment group, your content will not be retrievable.`,
  descriptionFieldLabel: `Description`,
  details: `Details`,
  discardChanges: `Discard changes`,
  discardChangesDialogMessage: `Your changes will be lost if you continue.`,
  discardChangesDialogTitle: `You have unsaved changes`,
  download: `Download`,
  editSuccessMetric: `Edit success metrics`,
  editSuccessMetricDescription: `Add success metrics to this segment by adding one or more event feeds. Only website behaviors are supported.`,
  email: `Email`,
  enterKeyPlaceholder: `Enter key`,
  error: `Error`,
  errorAttributeFormat: `Enter letters, numbers, dashes, underscores, and dollar signs only`,
  errorAttributeUnique: `Ensure attribute names are unique`,
  errorCollectionNameFormat: `Enter collection name in the required format`,
  errorCountNumber: `Enter numbers only`,
  errorIdInUse: `This ID is already in use`,
  errorKeyValue: `Enter lower case letters, numbers, dashes, hyphens, and underscores only.`,
  errorNameInUse: `This name is already in use`,
  errorRequiredAttribute: `Enter attribute`,
  errorRequiredCollection: `Enter collection name`,
  errorRequiredCollectionUnique: `Enter a unique collection name`,
  errorRequiredCustomName: `Custom id is required`,
  errorRequiredDataService: `Select data service`,
  errorRequiredEventName: `Enter event name`,
  errorRequiredField: `This field is required`,
  errorRequiredKey: `Enter key`,
  errorRequiredRule: `Select rule`,
  errorRequiredRuleset: `A rule set is required`,
  errorRequiredValue: `Enter value`,
  errorToastRequiredFields: `Some fields require attention before you can save.`,
  errorToastUnableToSave: `Unable to save`,
  eventAddTitle: `Add event`,
  eventBuilderAttributeIdLabel: `ID`,
  eventBuilderAttributeIdNote: `This ID is important for your developers and once saved, you cannot edit it`,
  eventBuilderAttributeIdPlaceholder: `ID will auto generate`,
  eventBuilderCollectionNameLabel: `Collection name`,
  eventBuilderCollectionNameNote: `The collection name must be in a specific format (e.g. /students/:{*}/assignments). Must be unique for each data service.`,
  eventBuilderCollectionNamePlaceholder: `Enter collection name`,
  eventBuilderDataServiceLabel: `Data service`,
  eventBuilderDataServicePlaceholder: `Select data service`,
  eventBuilderNameLabel: `Name`,
  eventBuilderNameNote: `Enter a unique name`,
  eventBuilderNamePlaceholder: `Enter name`,
  eventCreateFeed: `Create event feed`,
  eventCustomId: `Custom event ID`,
  eventCustomIdNote: `This ID is important for your developers and once saved, you cannot edit it`,
  eventCustomIdPlaceholder: `Enter ID`,
  eventDetails: `Details`,
  eventFeedDataIntegrationLabel: `Data integration event feed`,
  eventFeedLabel: `Website behavior event feed`,
  eventFeeds: `Event feeds`,
  eventFeedWebBehaviorLabel: `Web behavior event feed`,
  eventOccurrenceCount_one: `{{count}} time`,
  eventOccurrenceCount_other: `{{count}} times`,
  eventOccurrenceCountIn_one: `{{count}} time in`,
  eventOccurrenceCountIn_other: `{{count}} times in`,
  eventOccurrenceRelevanceDays_one: `{{count}} day`,
  eventOccurrenceRelevanceDays_other: `{{count}} days`,
  eventOccurrenceRelevanceHours_one: `{{count}} hour`,
  eventOccurrenceRelevanceHours_other: `{{count}} hours`,
  eventOccurrenceRelevanceMinutes_one: `{{count}} minute`,
  eventOccurrenceRelevanceMinutes_other: `{{count}} minutes`,
  events: `Event feeds`,
  eventsActionMenuAriaLabel: `Events item menu button`,
  eventsActionMenuDelete: `Delete`,
  eventsActionMenuView: `View details`,
  eventSourceNote: `This is where your event data comes from`,
  eventTimePeriodLabel: `Time period in days (optional)`,
  eventTimePeriodNote: `Enter the number of days you want to capture this event for`,
  eventTimePeriodPlaceholder: `Enter days`,
  eventType: `Event type`,
  exportError1: `The export of`,
  exportError2: `could not be generated.`,
  exportInProgress1: `The export of the`,
  exportInProgress2: `segment is in progress.`,
  exports: `Exports`,
  exportsAlert: `Export files are automatically deleted after 48 hours.`,
  finished: `Finished`,
  generateExportAsCsv: `Generate export as CSV`,
  generatingExport: `Generating export`,
  goToSegmentation: `Go to segmentation`,
  groupSwitcherLabelByHierarchy: `By hierarchy`,
  groupSwitcherLabelByRecency: `By recency`,
  groupSwitcherMultipleDescription: `A mutually exclusive group ensures each customer belongs to only one segment within a group. This requires at least two segments.`,
  groupSwitcherMultipleLabel: `Mutually exclusive group`,
  groupSwitcherPriorityDescription: `Manually set the segment priority. Customers will be assigned to the highest priority segment they have appeared in regardless of their most recent match.`,
  groupSwitcherRecencyDescription: `Customers will be assigned to the segment that they most recently appeared in.`,
  groupSwitcherSingleDescription: `Single segments allow you to organize customers based on specific criteria.`,
  groupSwitcherSingleLabel: `Single segment`,
  groupSwitcherTitle: `Mutually exclusive group details`,
  idFieldErrorMessageEmpty: `Enter a Segment ID`,
  idFieldErrorMessagePattern: `Enter lowercase letters, numbers and dashes only (up to 20 characters)`,
  idFieldLabel: `Segment ID`,
  idFieldNote: `This ID is important for your developers and once saved, you cannot edit it`,
  inProgress: `In progress`,
  lastUpdated: `Last updated`,
  mappedAttributes: `Mapped attributes`,
  name: `Name`,
  nameFieldErrorMessageEmpty: `Enter a segment name`,
  nameFieldLabel: `Name`,
  nameFieldNote: `Keep it short`,
  noCustomersCaption: `There are no customers in this segment.`,
  noEventsCaption: `There are no events to show yet`,
  noExports: `There are no exports available.`,
  noRecentEvents: `There are no events to show yet. Recent events will be available in a future release.`,
  noSegmentsCaption: `There are no segments yet`,
  noSuccessMetrics: `Metrics will be available within 4 hours of initial setup; if none are displayed after this period, no successful events have been recorded yet.`,
  noUndefinedAttributes: `All attributes have been mapped.`,
  overview: `Overview`,
  recentEvents: `Recent events`,
  removeEventFeed: `Remove event feed`,
  requiredAttribute: `Select an attribute`,
  requiredEventFeed: `Select an event feed`,
  requiredNumber: `Enter a number`,
  requiredRule: `Select a rule`,
  requiredSection: `This section is required`,
  requiredValue: `Enter a value`,
  rule: `Rule`,
  ruleButtonTextAdd: `Add a rule`,
  ruleButtonTextDelete: `Delete rule`,
  ruleOperatorLabel: `Rule matching logic`,
  ruleOperatorPlaceholder: `Select the rule logic`,
  ruleSelectLabel: `Rule`,
  ruleSelectPlaceholder: `Select a rule`,
  rulesetButtonTextAdd: `Add a rule set`,
  rulesetButtonTextDelete: `Delete rule set`,
  rulesetOperatorLabel: `Rule set matching logic`,
  rulesetOperatorPlaceholder: `Select a data service`,
  rulesetTitleDataIntegration: `Data integration rule set`,
  rulesetTitleWebsiteBehavior: `Website behavior rule set`,
  save: `Save`,
  saveChanges: `Save changes`,
  search: `Search`,
  segment: `Segment`,
  segmentActionMenuAriaLabel: `Segment item menu button`,
  segmentActionMenuDelete: `Delete`,
  segmentActionMenuView: `View details`,
  segmentActionMenuViewDetails: `View details`,
  segmentation: `Segmentation`,
  segmentationConfigurationApplySettingsButton: `Apply settings`,
  segmentationConfigurationHeader: `Segmentation configuration`,
  segmentationConfigurationUserProfileFieldLabel: `Select a data service for the user profile`,
  segmentationConfigurationUserProfilePlaceholder: `Please select a service`,
  segmentBuilder: `Create a segment`,
  segmentBuilderCreateButton: `Create`,
  segmentBuilderDetailsSection: `Details`,
  segmentBuilderRulesSection: `Rules`,
  segmentInsights: `Segment insights`,
  segmentPicker: `Segment picker`,
  segmentPickerDescription: `Select a segment to review its customers and journeys, and related segment analytics.`,
  segments: `Segments`,
  segmentSelect: `Select a segment`,
  selectEventFeed: `Select event feed`,
  selectEventFeeds: `Select event feeds`,
  selectEventTypePlaceholder: `Select event type`,
  settings: `Settings`,
  settingsUpdatedFailToast: `Settings failed to update`,
  settingsUpdatedSuccessToast: `Settings updated`,
  singleCustomerView: `Single customer view`,
  sourceLabel: `Source`,
  status: `Status`,
  successMetric: `Success metric`,
  successMetricAddedDescriptionOne: `You have successfully added the success metrics for `,
  successMetricAddedDescriptionTwo: ` segment.`,
  successMetricAddedTitle: `Success metrics added`,
  successMetricDialogDescription: `To add a success metrics to this segment, select a website behavior event feed below.`,
  successMetricEmptyStateDescription: `There are no success metrics added to this segment yet.`,
  successMetrics: `Success metrics`,
  successMetricsFormErrorMessage: `You must select one or more event feeds`,
  tableHeaderEventName: `Event feed name`,
  tableHeaderEventSource: `Source`,
  tableHeaderEventType: `Event type`,
  tableHeaderMappedFields: `Mapped fields`,
  timePeriodLabel: `Time period`,
  toastErrorLabel: `Changes could not be saved`,
  toastErrorTitle: `Error`,
  toastEventFailAddedMessage: `The event`,
  toastEventFailAddedMessageEnd: `could not be added`,
  toastEventFailDeletedMessage: `The event`,
  toastEventFailUpdatedMessageEnd: `could not be updated`,
  toastEventSuccessAddedMessage: `You have successfully added`,
  toastEventSuccessAddedMessageEnd: `event.`,
  toastEventSuccessAddedTitle: `Added`,
  toastEventSuccessUpdatedTitle: `Changes saved`,
  toastSuccessCreateLabel: `Created`,
  toastSuccessCreateMessage: `You have successfully created`,
  toastSuccessCreateMessageEnd: `segment.`,
  toastSuccessDeleteGroupLabel: `Segment group deleted`,
  toastSuccessDeleteGroupMessage: `You have successfully deleted`,
  toastSuccessDeleteGroupMessageEnd: `segment group.`,
  toastSuccessDeleteLabel: `Deleted`,
  toastSuccessDeleteMessage: `You have successfully deleted`,
  toastSuccessDeleteMessageEnd: `segment.`,
  toastSuccessSegmentDeleteLabel: `Segment deleted`,
  toastSuccessUpdateLabel: `Changes saved`,
  undefinedAttributes: `Undefined attributes`,
  valueFieldLabel: `Value`,
  valueFieldPlaceholder: `Enter a value`,
  viewAllAttributes: `View all attributes`,
  viewExports: `View Exports`,
  websiteBehavior: `Website behavior`,
};
